import {Component, OnInit} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material';
import {environment} from '../../../environments/environment.prod';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
    isLoading = false;
    pageTitle: any;
    currentTabIndex: number;
    localEnvironment = environment;
    constructor() {
        this.pageTitle = 'Αναφορές';
    }

    async ngOnInit() {
        this.currentTabIndex = 0;
    }

    onTabChanged($event: MatTabChangeEvent) {
        console.log($event);
        this.currentTabIndex = $event.index;
    }
}
